import { useStoreLabelMutation } from "api/TenantSlug/Label/hooks.ts";
import { DEFAULT_VALUES } from "components/Forms/LabelsForm/constants.ts";
import { LabelFormData, schema } from "components/Forms/LabelsForm/schema.ts";
import { SharedLabelFormContent } from "components/Forms/LabelsForm/SharedLabelFormContent.tsx";
import { GeneralFormProvider } from "components/UI/GeneralForm/GeneralFormProvider.tsx";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm.ts";
import { FC } from "react";
import { toast } from "react-toastify";
import { FormId } from "types/models.ts";

interface AddLabelFormProps {
    onSuccess: () => void;
}

export const AddLabelForm: FC<AddLabelFormProps> = ({ onSuccess }) => {
    const formId = FormId.AddLabel;
    const { handleErrorsFromErrorResponse } = useGeneralForm<LabelFormData>();

    const { mutate } = useStoreLabelMutation();

    const handleSubmit = (data: LabelFormData) => {
        mutate(
            { ...data, color: data.color ?? null },
            {
                onSuccess: () => {
                    onSuccess();
                    toast.success("Label successfully created");
                },
                onError: (error) => {
                    handleErrorsFromErrorResponse(error);
                    toast.error(`Failed to create label: ${(error as Error)?.message ?? "Unknown error"}`);
                },
            }
        );
    };

    return (
        <GeneralFormProvider id={formId} schema={schema} defaultValues={DEFAULT_VALUES} onSubmit={handleSubmit}>
            <SharedLabelFormContent />
        </GeneralFormProvider>
    );
};
